module.exports = __webpack_public_path__ + "static/img/answer-tickets.add29923.png";